import { render, staticRenderFns } from "./ContactsTableCell.vue?vue&type=template&id=3b954685"
import script from "./ContactsTableCell.vue?vue&type=script&lang=js"
export * from "./ContactsTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports